export default __webpack_public_path__ + "static/media/circle-cross-2.1822cc8d.svg";